import React from 'react';
import {
    Button,
    CssBaseline,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import qs from 'qs';
import isEmpty from 'lodash/isEmpty';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import findIndex from 'lodash/findIndex';

import { ContactsOutlined } from '@material-ui/icons';
import moment from 'moment-timezone';
import Layout from '../Layout';
import PageHeader from '../../components/pageHeader';
import ItemTabs from '../../components/v2/itemTabs';
import fetch, { fetchJson2 } from '../../utilities/fetch';
import sleep from '../../utilities/sleep';

const { REACT_APP_API_SERVER } = process.env;
const currentDateTime = moment.tz(moment(), 'Europe/London');

const removeFalseyValuesFromObject = (obj) => pickBy(obj, identity);

const styles = (theme) => ({
});

class Item extends React.Component {
    state = {
        item: null,
        itemChildren: null,
        itemChildrenLoading: true,
        itemHistoriesLoading: true,
        itemLoading: true,
    };

    static getDerivedStateFromProps(props) {
        const { itemCode } = props.match.params;
        return {
            itemCode,
        };
    }

    componentDidMount() {
        const { itemCode } = this.state;
        this.fetchItemViewData(itemCode);
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.match.params.itemCode !== prevProps.match.params.itemCode) {
            await this.setDefaults();
            this.fetchItemViewData(this.props.match.params.itemCode);
            window.scrollTo(0, 0);
        }
    };

    setDefaults = async () => {
        this.setState({
            errors: {},
            itemCode: null,
            itemLoading: true,
            itemHistoryLoading: true,
            itemChildrenLoading: true,
        });
    };

    fetchItemViewData = async (itemCode) => {
        await fetchJson2('v2/user')
            .then((user) => {
                this.setState({
                    user: user.payload,
                    userLoading: false,
                });
            });
        const itemData = this.fetchItemData();
        // fetchJson2('v2/product/types')
        //     .then((productTypes) => {
        //         this.setState({ productTypes: productTypes.payload });
        //     });
        itemData.then(() => { // Dependent on the item
            this.fetchHistoriesData();
            this.fetchItemChildrenData();
        });
        this.setState({ itemCode });
    };

    fetchItemData = async () => {
        const { itemCode } = this.state;
        this.setState({
            itemLoading: true,
        });

        try {
            const [item] = await Promise.all([fetchJson2(`v2/item/${itemCode}`), sleep(50)]);

            this.setState((state) => ({
                item: {
                    ...state.item,
                    ...item.payload,
                },
            }));
        } finally {
            this.setState({
                itemLoading: false,
            });
        }
    };

    fetchHistoriesData = async () => {
        const { itemCode } = this.state;
        this.setState({
            itemHistoriesLoading: true,
        });

        try {
            const histories = await fetchJson2(`v2/item/${itemCode}/histories`);

            this.setState((state) => ({
                item: {
                    ...state.item,
                    histories: histories.payload,
                },
            }));
        } finally {
            this.setState({
                itemHistoriesLoading: false,
            });
        }
    };

    fetchItemChildrenData = async () => {
        const { itemCode } = this.state;
        this.setState({
            itemChildrenLoading: true,
        });

        try {
            const children = await fetchJson2(`v2/item/${itemCode}/children`);
            this.setState((state) => ({
                item: {
                    ...state.item,
                    children: children.payload,
                },
            }));
        } finally {
            this.setState({
                itemChildrenLoading: false,
            });
        }
    };

    fetchContactSecurityAnswers = async () => {
        const { contactCode } = this.state;
        this.setState({
            contactSecurityAnswersLoading: true,
        });

        try {
            // const [securityAnswers] = await Promise.all([fetchJson(`https://api.portal2.payweeklycarpets.co.uk/core/v2/contact/${contactCode}/securityAnswers`), sleep(50)]);
            const [securityAnswers] = await Promise.all([fetchJson2(`v2/contact/${contactCode}/securityAnswers`), sleep(50)]);

            this.setState((state) => ({
                contact: {
                    ...state.contact,
                    securityAnswers: securityAnswers.payload,
                },
            }));
            console.log('>>> securityAnswers:', securityAnswers);
        } finally {
            this.setState({
                contactSecurityAnswersLoading: false,
            });
        }
    };

    fetchContactVulnerabilities = async () => {
        const { contactCode } = this.state;
        this.setState({
            contactVulnerabilitiesLoading: true,
        });

        try {
            const [vulnerabilities] = await Promise.all([fetchJson2(`v2/contact/${contactCode}/vulnerabilities`), sleep(50)]);

            this.setState((state) => ({
                contact: {
                    ...state.contact,
                    vulnerabilities: vulnerabilities.payload,
                },
            }));
            console.log('>>> Vulnerabilities:', vulnerabilities);
        } finally {
            this.setState({
                contactVulnerabilitiesLoading: false,
            });
        }
    };

    fetchContactCreditReport = async () => {
        const { contactCode } = this.state;
        this.setState({
            contactCreditReportLoading: true,
        });

        try {
            const [creditReport] = await Promise.all([fetchJson2(`v2/contact/${contactCode}/creditReports`), sleep(50)]);

            this.setState((state) => ({
                contact: {
                    ...state.contact,
                    creditReport: creditReport.payload,
                },
            }));
            console.log('>>> CreditReport:', creditReport);
        } finally {
            this.setState({
                contactCreditReportLoading: false,
            });
        }
    };

    fetchContactContactAgents = async () => {
        const { contactCode } = this.state;
        this.setState({
            contactContactAgentsLoading: true,
        });

        try {
            const [agents] = await Promise.all([fetchJson2(`v2/contact/${contactCode}/agent`), sleep(50)]);

            this.setState({
                contactContactAgents: agents.payload,
            });
            console.log('>>> contactContactAgents:', agents.payload);
        } finally {
            this.setState({
                contactContactAgentsLoading: false,
            });
        }
    };

    render() {
        const {
        } = this.props;
        const {
            item,
            itemLoading,
            itemHistoriesLoading,
            itemChildrenLoading,
            user,
        } = this.state;

        const pageHeaderContent = itemLoading
            ? {
                leftText: ' ',
                leftTitle: 'Loading...',
            } : {
                leftText: `${item.product.manufacturer}`,
                leftTitle: `${item.product.modelNo}`,
                rightTitle: `SC${item.code}`,
            };

        // let currencySymbol = '';
        // if (!itemLoading) {
        //     switch (item.currency) {
        //     case 'GBP': currencySymbol = '£';
        //         break;
        //     case 'EUR': currencySymbol = '€';
        //         break;
        //     default: currencySymbol = '?';
        //     }
        // }
        // const customerVisitAddDialogLoading = (engineersLoading);

        return (
            <Layout pageTitle="Item">
                <CssBaseline />
                <PageHeader
                    content={pageHeaderContent}
                    history={this.props.history}
                />
                {/* <ContactBadges
                    item={item}
                    itemHistories={itemHistories}
                    itemHistoriesLoading={itemHistoriesLoading}
                /> */}
                <ItemTabs
                    fetchHistoriesData={this.fetchHistoriesData}
                    fetchItemData={this.fetchItemData}
                    item={item}
                    itemLoading={itemLoading}
                    itemHistoriesLoading={itemHistoriesLoading}
                    itemChildrenLoading={itemChildrenLoading}
                    user={user}
                />
            </Layout>
        );
    }
}

export default withStyles(styles)(Item);
